import React from 'react';
import { ArrowDown } from 'lucide-react';
import { Button } from '../components/ui/button';

const colors = {
  gold: '#c9a227',
  tealArmonizador: '#00675b',
};

const ImagePositionTest = () => {
  const newPhotoUrl = "https://customer-assets.emergentagent.com/job_light-school-1/artifacts/zbiejhmz_Gemini_Generated_Image_1x9m5f1x9m5f1x9m.png";

  const positions = [
    { name: "object-right", label: "Posición: RIGHT (derecha)", style: "object-right" },
    { name: "object-[80%]", label: "Posición: 80% (más a la derecha)", style: "object-[80%_top]" },
    { name: "object-[90%]", label: "Posición: 90% (muy a la derecha)", style: "object-[90%_top]" },
    { name: "object-[100%]", label: "Posición: 100% (extremo derecho)", style: "object-[100%_top]" },
  ];

  return (
    <div className="pt-20 bg-gray-100 min-h-screen">
      {/* Header */}
      <div className="bg-gray-900 text-white py-6 px-6 text-center">
        <h1 className="text-2xl font-bold">Posicionamiento de tu imagen</h1>
        <p className="text-gray-300 mt-2">Elige dónde quieres que aparezca tu cuerpo</p>
      </div>

      {/* Options */}
      <div className="max-w-7xl mx-auto px-4 py-8 space-y-12">
        
        {/* Option 1: object-right */}
        <div>
          <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
            OPCIÓN 1: object-right (derecha estándar)
          </h2>
          <div className="relative h-[450px] rounded-2xl overflow-hidden shadow-xl">
            <div className="absolute inset-0">
              <img 
                src={newPhotoUrl}
                alt="Herminio"
                className="w-full h-full object-cover object-right"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-white from-30% via-white/40 via-50% to-transparent to-70%" />
            </div>
            <div className="relative h-full flex items-center">
              <div className="max-w-xl px-8 lg:px-12 space-y-4">
                <div className="w-12 h-[2px]" style={{ backgroundColor: colors.gold }} />
                <h1 className="text-4xl font-serif text-gray-800 leading-tight">
                  Un espacio para volver a ti.
                  <span className="block mt-2" style={{ color: colors.tealArmonizador }}>Sin prisa. Sin ruido.</span>
                </h1>
                <p className="text-gray-600">De la desconexión a habitar tu vida con claridad.</p>
                <Button style={{ backgroundColor: colors.gold }} className="text-white px-6 py-5">
                  Descarga el ebook <ArrowDown className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Option 2: 75% */}
        <div>
          <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
            OPCIÓN 2: 75% hacia la derecha
          </h2>
          <div className="relative h-[450px] rounded-2xl overflow-hidden shadow-xl">
            <div className="absolute inset-0">
              <img 
                src={newPhotoUrl}
                alt="Herminio"
                className="w-full h-full object-cover"
                style={{ objectPosition: '75% top' }}
              />
              <div className="absolute inset-0 bg-gradient-to-r from-white from-30% via-white/40 via-50% to-transparent to-70%" />
            </div>
            <div className="relative h-full flex items-center">
              <div className="max-w-xl px-8 lg:px-12 space-y-4">
                <div className="w-12 h-[2px]" style={{ backgroundColor: colors.gold }} />
                <h1 className="text-4xl font-serif text-gray-800 leading-tight">
                  Un espacio para volver a ti.
                  <span className="block mt-2" style={{ color: colors.tealArmonizador }}>Sin prisa. Sin ruido.</span>
                </h1>
                <p className="text-gray-600">De la desconexión a habitar tu vida con claridad.</p>
                <Button style={{ backgroundColor: colors.gold }} className="text-white px-6 py-5">
                  Descarga el ebook <ArrowDown className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Option 3: 85% */}
        <div>
          <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
            OPCIÓN 3: 85% hacia la derecha
          </h2>
          <div className="relative h-[450px] rounded-2xl overflow-hidden shadow-xl">
            <div className="absolute inset-0">
              <img 
                src={newPhotoUrl}
                alt="Herminio"
                className="w-full h-full object-cover"
                style={{ objectPosition: '85% top' }}
              />
              <div className="absolute inset-0 bg-gradient-to-r from-white from-30% via-white/40 via-50% to-transparent to-70%" />
            </div>
            <div className="relative h-full flex items-center">
              <div className="max-w-xl px-8 lg:px-12 space-y-4">
                <div className="w-12 h-[2px]" style={{ backgroundColor: colors.gold }} />
                <h1 className="text-4xl font-serif text-gray-800 leading-tight">
                  Un espacio para volver a ti.
                  <span className="block mt-2" style={{ color: colors.tealArmonizador }}>Sin prisa. Sin ruido.</span>
                </h1>
                <p className="text-gray-600">De la desconexión a habitar tu vida con claridad.</p>
                <Button style={{ backgroundColor: colors.gold }} className="text-white px-6 py-5">
                  Descarga el ebook <ArrowDown className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Option 4: 95% */}
        <div>
          <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
            OPCIÓN 4: 95% hacia la derecha (máximo)
          </h2>
          <div className="relative h-[450px] rounded-2xl overflow-hidden shadow-xl">
            <div className="absolute inset-0">
              <img 
                src={newPhotoUrl}
                alt="Herminio"
                className="w-full h-full object-cover"
                style={{ objectPosition: '95% top' }}
              />
              <div className="absolute inset-0 bg-gradient-to-r from-white from-30% via-white/40 via-50% to-transparent to-70%" />
            </div>
            <div className="relative h-full flex items-center">
              <div className="max-w-xl px-8 lg:px-12 space-y-4">
                <div className="w-12 h-[2px]" style={{ backgroundColor: colors.gold }} />
                <h1 className="text-4xl font-serif text-gray-800 leading-tight">
                  Un espacio para volver a ti.
                  <span className="block mt-2" style={{ color: colors.tealArmonizador }}>Sin prisa. Sin ruido.</span>
                </h1>
                <p className="text-gray-600">De la desconexión a habitar tu vida con claridad.</p>
                <Button style={{ backgroundColor: colors.gold }} className="text-white px-6 py-5">
                  Descarga el ebook <ArrowDown className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Option 5: 140% */}
        <div>
          <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
            OPCIÓN 5: 140% hacia la derecha
          </h2>
          <div className="relative h-[450px] rounded-2xl overflow-hidden shadow-xl">
            <div className="absolute inset-0">
              <img 
                src={newPhotoUrl}
                alt="Herminio"
                className="w-full h-full object-cover"
                style={{ objectPosition: '140% top' }}
              />
              <div className="absolute inset-0 bg-gradient-to-r from-white from-30% via-white/40 via-50% to-transparent to-70%" />
            </div>
            <div className="relative h-full flex items-center">
              <div className="max-w-xl px-8 lg:px-12 space-y-4">
                <div className="w-12 h-[2px]" style={{ backgroundColor: colors.gold }} />
                <h1 className="text-4xl font-serif text-gray-800 leading-tight">
                  Un espacio para volver a ti.
                  <span className="block mt-2" style={{ color: colors.tealArmonizador }}>Sin prisa. Sin ruido.</span>
                </h1>
                <p className="text-gray-600">De la desconexión a habitar tu vida con claridad.</p>
                <Button style={{ backgroundColor: colors.gold }} className="text-white px-6 py-5">
                  Descarga el ebook <ArrowDown className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* Instructions */}
      <div className="py-8 bg-gray-900 text-white text-center">
        <h2 className="text-xl font-bold mb-4">¿Cuál te gusta más?</h2>
        <p className="text-gray-300">Dime el número de opción (1, 2, 3 o 4)</p>
      </div>
    </div>
  );
};

export default ImagePositionTest;
